"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const createJourneyComponent_1 = require("../../lib/createJourneyComponent");
const Chip = createJourneyComponent_1.createJourneyComponent('j-chip', 'div');
exports.default = Chip;
